export default __webpack_public_path__ + "static/media/A6_printing_rules_mm.775776c9.pdf";